"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _get = _interopRequireDefault(require("lodash/get"));
var _OutsideElement = _interopRequireDefault(require("../OutsideElement"));
var _BrixelIcon = _interopRequireDefault(require("../BrixelIcon"));
var _BrixelTooltip = _interopRequireDefault(require("../BrixelTooltip"));
var _DebounceHook = _interopRequireDefault(require("../DebounceHook"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const BrixelSelect = /*#__PURE__*/(0, _react.forwardRef)((props, refs) => {
  const {
    bigDropDown = false,
    className = '',
    compact = false,
    disableDelay = false,
    disabled = false,
    flagWrapperWidth = 0,
    flags = false,
    input,
    label = null,
    labelType = 'full',
    liClass = '',
    message = {},
    options = [],
    meta = {
      dirty: undefined,
      invalid: undefined
    },
    modal = null,
    placeholder = '',
    showError = false,
    ulClass = '',
    validation = false,
    large = false,
    wrapClass = '',
    tooltip
  } = props;
  // STATE
  const [dropdownOpen, setDropdownOpen] = (0, _react.useState)(false);
  const [currentValue, setCurrentValue] = (0, _react.useState)(input.value);
  const [paddingSelect, setPaddingSelect] = (0, _react.useState)(input.value);
  const [countryCodeVal, setCountryCodeVal] = (0, _react.useState)(null);
  const [countryCodeValCountry, setCountryCodeValCountry] = (0, _react.useState)('ch');
  const [countryName, setCountryName] = (0, _react.useState)('ch');
  const debouncedSearchTerm = (0, _DebounceHook.default)(currentValue, disableDelay ? 0 : 500);
  // REF
  const wrapperRef = (0, _react.useRef)(null);
  const listItemRef = (0, _react.useRef)(null);
  const dialCodeRef = (0, _react.useRef)(null);
  // DOM
  const wrapperEl = wrapperRef.current;
  const getLabelFormValue = () => {
    if (options) {
      const getCurVal = options.find(val => val.value === input.value);
      let defLabel = getCurVal ? getCurVal.label : null;
      if (labelType === 'short') defLabel = getCurVal ? getCurVal.shortLabel : null;
      if (labelType === 'onlyFlag') defLabel = getCurVal ? getCurVal.onlyFlag : null;
      return defLabel;
    }
    return null;
  };
  (0, _react.useEffect)(() => {
    if (wrapperEl && input.changePadding) {
      if (wrapperEl.offsetWidth + 4 !== paddingSelect) {
        input.changePadding(wrapperEl.offsetWidth + 4);
        setPaddingSelect(wrapperEl.offsetWidth + 4);
      }
    }
  });
  const dropdownOnChange = (value, ignoreCloseDropdown, country) => {
    setCurrentValue(value);
    if (!ignoreCloseDropdown) setDropdownOpen(false);
    if (dialCodeRef && dialCodeRef.current) {
      let getCurVal = options.find(val => val.value === value);
      if (country) {
        setCountryName(country);
        const getCurVals = options.find(val => val.value === value && val.country === country);
        getCurVal = getCurVals || getCurVal;
      }
      const dialCode = (getCurVal ? getCurVal.value : '0').replace('+', '');
      setCountryCodeVal(`+${dialCode}`);
      let getCurValCountry = getCurVal ? getCurVal.label.toLowerCase() : null;
      if (!country) {
        if (getCurValCountry === 'ca') getCurValCountry = 'us';
      }
      setCountryCodeValCountry(getCurValCountry);
    }
  };
  (0, _react.useEffect)(() => {
    dropdownOnChange(input.value || '', true, countryName);
  }, [input.value, options]);
  (0, _react.useEffect)(() => {
    if (input.onChange && input.value !== currentValue && !disableDelay && options.length > 0) {
      input.onChange(currentValue);
    }
  }, [debouncedSearchTerm]);
  (0, _react.useEffect)(() => {
    if (input.onChange && input.value !== currentValue && disableDelay && options.length > 0) {
      input.onChange(currentValue);
    }
  }, [currentValue]);
  (0, _OutsideElement.default)(wrapperRef, {
    action: 'function',
    func: () => setDropdownOpen(false)
  });
  (0, _react.useEffect)(() => {
    const listItemsEl = listItemRef.current;
    if (listItemsEl && typeof listItemsEl === 'object') {
      listItemsEl.scrollIntoView({
        block: 'nearest',
        behavior: 'smooth'
      });
    }
  }, [dropdownOpen]);
  // genarate css classes fuctions
  const inputClassFunc = (0, _react.useCallback)(() => {
    let inClasses = '';
    if (disabled) inClasses += ' disabled ';
    if (meta.dirty && !meta.invalid) inClasses += ' valid ';
    if (meta.dirty) inClasses += ' dirty-icon ';
    if (meta.dirty && meta.invalid) inClasses += ' error ';
    if (large) inClasses += ' large ';
    return inClasses;
  }, [meta, disabled, input.value]);
  const dropDownBorder = () => {
    if (meta.dirty && meta.invalid) return 'brdRed200';
    if (dropdownOpen) return 'brdPrimary400';
    return 'brdText200';
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: `brixel-select-wrapper ${wrapClass || ''}`,
    ref: refs
  }, label && (/*#__PURE__*/_react.default.createElement("label", {
    htmlFor: input.name,
    className: `brixel-label ${tooltip ? 'wTooltip' : ''} ${large ? 'labelLarge' : ''}`
  }, /*#__PURE__*/_react.default.createElement("span", null, /*#__PURE__*/_react.default.createElement("span", {
    className: `va-tb ${tooltip ? 'mr-1' : ''}`
  }, label), tooltip && (/*#__PURE__*/_react.default.createElement(_BrixelTooltip.default, {
    className: "dis-ib",
    label: tooltip.label,
    width: tooltip.width,
    description: tooltip.description,
    theme: tooltip.theme
  }))))), /*#__PURE__*/_react.default.createElement("div", {
    className: `brixel-select ${inputClassFunc()} ${flags ? 'flags' : ''}`
  }, typeof window !== 'undefined' && window.innerWidth < 768 ? (/*#__PURE__*/_react.default.createElement("div", {
    className: `mobile-version bgWhite ${dropdownOpen ? 'focus' : 'unfocus'} ${disabled ? 'disabled' : ''} ${flags ? 'max-w-fix-112 w-fix-112 mr-2' : ''}`
  }, /*#__PURE__*/_react.default.createElement("select", {
    className: !input.value ? 'placeholder' : '',
    "data-validation": validation,
    name: input.name,
    onChange: e => setCurrentValue(e.target.value),
    disabled: disabled,
    onFocus: () => {
      setDropdownOpen(true);
    },
    onBlur: () => {
      setDropdownOpen(false);
    },
    value: input.value
  }, /*#__PURE__*/_react.default.createElement("option", {
    className: "placeholderOption",
    value: "",
    disabled: true
  }, placeholder), options.map((opt, i) => (/*#__PURE__*/_react.default.createElement(_react.default.Fragment, {
    key: `opt_${i.toString()}`
  }, !flags ? (/*#__PURE__*/_react.default.createElement("option", {
    value: opt.value
  }, opt.label)) : (/*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("option", {
    value: opt.value
  }, `${opt.label} ${opt.value}`))))))))) : (/*#__PURE__*/_react.default.createElement("div", {
    className: `dropdown ${compact ? 'compact' : ''} ${className} ${dropdownOpen ? 'open' : 'close'} brdRadius ${dropDownBorder()} brdSmall ${disabled ? 'disabled' : ''} ${bigDropDown ? 'large' : ''} ${flags ? 'max-w-fix- w-fix-' : ''}`,
    ref: wrapperRef
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "hide"
  }, /*#__PURE__*/_react.default.createElement("select", {
    id: input.name,
    name: input.name,
    onChange: e => setCurrentValue(e.target.value),
    disabled: disabled,
    value: input.value
  }, /*#__PURE__*/_react.default.createElement("option", {
    value: "",
    disabled: true
  }, placeholder || 'Select'), options.map((opt, i) => (/*#__PURE__*/_react.default.createElement("option", {
    value: opt.value,
    key: `opt_${i.toString()}`
  }, opt.label))))), /*#__PURE__*/_react.default.createElement("div", {
    className: "selElement",
    onClick: () => !disabled ? setDropdownOpen(!dropdownOpen) : ''
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: `dis-fl-row a-c ${flags ? 'jc-c flagItems' : 'jc-b'}`
  }, !flags ? (/*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("span", {
    className: "title",
    dangerouslySetInnerHTML: {
      __html: getLabelFormValue() || placeholder
    }
  }), /*#__PURE__*/_react.default.createElement(_BrixelIcon.default, {
    saturationTxt: disabled ? 400 : 700,
    saturation: disabled ? 400 : 700,
    color: disabled ? 'text' : '',
    icon: dropdownOpen ? 'dropdown-open' : 'dropdown-close'
  }))) : (/*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("span", {
    className: `iti__flag selected iti__${countryCodeValCountry}`
  }), /*#__PURE__*/_react.default.createElement("span", {
    className: "flagArrow"
  }), /*#__PURE__*/_react.default.createElement("span", {
    className: `current ${countryCodeVal ? 'pl-1' : ''}`,
    ref: dialCodeRef
  }, countryCodeVal))))), /*#__PURE__*/_react.default.createElement("ul", {
    ref: listItemRef,
    className: `dropdownUl shadow-4dp ${ulClass} left ${flags ? 'flagDropdown' : ''} ${labelType === 'onlyFlag' ? 'w-fit' : ''}`,
    style: {
      width: flags ? `${flagWrapperWidth}px` : 0
    }
  }, options.map((opt, i) => (/*#__PURE__*/_react.default.createElement("li", {
    className: `flagItems ${liClass} ${opt.value === input.value ? 'active' : ''} ws-nw`,
    key: `opt_${i.toString()}`,
    onClick: () => dropdownOnChange(opt.value, false, opt.country)
  }, !flags && (/*#__PURE__*/_react.default.createElement("p", {
    className: "dis-fl-row a-c jc-b w-perc-100"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: `${opt.label === getLabelFormValue() ? 'txtGreen400' : ''} ${liClass}`
  }, opt.label), opt.label === getLabelFormValue() && (/*#__PURE__*/_react.default.createElement(_BrixelIcon.default, {
    color: "green",
    icon: "check"
  })))), flags && (/*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("span", {
    className: `iti__flag iti__${opt.label.toLowerCase()}`
  }), /*#__PURE__*/_react.default.createElement("span", {
    className: "fsize-200"
  }, "\u00A0 ", opt.country, " \u00A0 ", opt.value, " ")))))))))), ((0, _get.default)(message, 'help', null) || (0, _get.default)(meta, 'invalid', null) && showError) && (/*#__PURE__*/_react.default.createElement("span", {
    className: `message ${(0, _get.default)(meta, 'dirty', null) && (0, _get.default)(meta, 'invalid', null) ? 'error-message' : ''}`
  }, (0, _get.default)(meta, 'dirty', null) && (0, _get.default)(meta, 'invalid', null) && showError ? (0, _get.default)(message, 'error', '') : (0, _get.default)(message, 'help', ''))), modal && (/*#__PURE__*/_react.default.createElement("span", {
    onClick: e => modal.func ? modal.func(e) : '',
    className: `message ${modal.func ? 'cur-poi' : ''} ${modal.className || ''}`,
    dangerouslySetInnerHTML: {
      __html: modal.message || ''
    }
  })));
});
BrixelSelect.displayName = 'BrixelSelect';
var _default = exports.default = BrixelSelect;